import { gql } from '@apollo/client';

const GET_DRIVER_BILLWEEK_LIMIT_DATES = {
  query: gql`
    query GetDriverBillWeeksLimitDates(
      $uid: ID!
      $initialDatetime: String
      $finalDatetime: String
    ) {
      getDriverBillDaysLimitDates(
        uid: $uid
        initialDatetime: $initialDatetime
        finalDatetime: $finalDatetime
      ) {
        installment
        date
        km
        references {
          field
          type
          amount
          uid
          rol
          base
          kms
        }
        traveledSections {
          startKm
          endKm
          variable
          traveled
        }
        currency
        category
        discount
        uber {
          category
          amount
          datetime
        }
        tag {
          amount
          address
          datetimeWindow
        }
        expenses {
          fines
          penaltys
          guarantee
          rent
          tag
          other
        }
        plan {
          startDate
          planName
          sections {
            variable
            endKm
            startKm
          }
          plan {
            name
            _id
            sections {
              variable
              endKm
              startKm
            }
          }
          selectedShifts {
            basePrice
          }
        }
        incomes {
          uber
          didi
          cabify
          beat
          other
        }
        events {
          chargeDate
          createdAt
          updatedAt
          title
          type
          amount
          description
          subject
          status
          charged {
            billRef
            rol
            ref
          }
          credited {
            billRef
            rol
            ref
          }
          files {
            url
            name
          }
        }
        uberBreakdown {
          adjustment
          cashCollected
          netFare
          other
          taxes
          promotions
          tips
          toll
        }
      }
    }
  `,
  policies: {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: 'true',
    errorPolicy: 'all',
  },
};

export default GET_DRIVER_BILLWEEK_LIMIT_DATES;
